var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchApplied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2161 15.0583L14.1001 10.9807V21.1875C14.1001 21.6845 14.5031 22.0875 15.0001 22.0875C15.4972 22.0875 15.9001 21.6845 15.9001 21.1875V10.9804L19.7843 15.0583L19.7843 15.0583C20.1272 15.4182 20.6969 15.4319 21.0568 15.0892L21.0568 15.0892C21.4166 14.7464 21.4306 14.1767 21.0877 13.8167L15.7877 8.25257L15.7877 8.25251C15.6148 8.07114 15.394 7.96248 15.1646 7.92755C15.1111 7.91765 15.0561 7.9125 15.0001 7.9125C14.9439 7.9125 14.8884 7.9177 14.8344 7.92779C14.6055 7.96296 14.3852 8.07154 14.2128 8.25256L14.2128 8.25257L8.91279 13.8167C8.56993 14.1766 8.58382 14.7464 8.94371 15.0892L8.94375 15.0892C9.30363 15.4319 9.87328 15.4182 10.2161 15.0583L10.2161 15.0583Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.675
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchApplied);
export default __webpack_public_path__ + "static/media/search_applied.1841c24ab4ec8c9d714feb371c79dc67.svg";
export { ForwardRef as ReactComponent };